<template>
  <div>
    <span class="fas fa-chevron-left previous-button-icon"></span>
    <button type="button" @click="goTo()">{{ previousLabel }}</button>
  </div>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "PreviousNavLink",
  props: {
    previousPageName: {
      type: String,
      default: ""
    },
    previousLabel: {
      type: String,
      default: ""
    },
    goToLink: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const router = useRouter();
    const goTo = () => {
      if (props.goToLink) {
        router.push(props.goToLink);
      } else {
        router.back();
      }
    };
    return { goTo };
  }
};
</script>

<style lang="scss" scoped>
.previous-button-icon {
  color: #356C9A;
}

button {
  border: none;
  background-color: transparent;
  font-size: 16px;
  text-decoration: underline;
  color: #356C9A;

  span {
    text-decoration: underline;
  }
}
</style>